import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { handleSendMail } from "./MailService";
function EventCard({
  event_date,
  event_time,
  title,
  description,
  registrationEndDate,
  applicableRoles = [],
  specialEligibilityCriteria = [],
  totalAllowedParticipants,
  onClick,
  formData
}) {
  const calculateDaysLeft = () => {
    const currentDate = new Date(); // Current date
    const targetDate = new Date(event_date); // Event date

    // Calculate the difference in time (milliseconds)
    const timeDifference = targetDate - currentDate;

    // Convert time difference from milliseconds to days
    const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    // Return 0 if the event date has already passed
    return daysLeft > 0 ? daysLeft : 0;
  };

  function convertTo12Hour(time24) {
    // Split the time string into hours and minutes
    const [hour, minute] = time24.split(":");
    const hourNum = parseInt(hour, 10);
  
    // Determine AM or PM based on the hour
    const period = hourNum >= 12 ? "PM" : "AM";
  
    // Convert to 12-hour format (e.g., 14 becomes 2 PM)
    const hour12 = hourNum % 12 || 12; // If hourNum is 0 or 12, it should display as 12
  
    // Return the formatted time as a string
    return `${String(hour12).padStart(2, "0")}:${minute} ${period}`;
  }
  
  const imageCodes = [2150671118, 2150671122, 2150671136, 2150671140, 2150671142];

  const navigate = useNavigate();

  const handleOpen = () => {
    navigate("/admin/selectparticipant", { state : { id: formData.id ,eventName: formData.name, maxParticipants: formData.totalAllowedParticipants}})
  };

  return (
    <div
      className="relative top-0 w-full sm:w-[95%] md:w-[850px] max-w-full mx-auto cursor-pointer transition-transform transform scale-95 hover:scale-100"
      onClick={onClick}
    >
      {/* Card Container */}
      <div className="bg-gradient-to-r from-blue-500 via-blue-600 to-blue-800 rounded-lg shadow-xl overflow-hidden">
        
        {/* Header */}
        <div className="w-full h-2 bg-gradient-to-r from-[var(--color-fill)] to-[var(--color-contrast)]"></div>

        {/* Content Container */}
        <div className="p-6 bg-white rounded-b-lg">
          
          {/* Event Date and Countdown */}
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-700 mb-2">
            <h1 className="font-semibold text-gray-800">
              {event_date} - {convertTo12Hour(event_time)}
            </h1>
            <h1
              className={`font-semibold ${
                calculateDaysLeft() > 10 ? "text-green-500" : "text-red-500"
              }`}
            >
              {calculateDaysLeft()} days left
            </h1>
          </div>

          {/* Event Title */}
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-3 leading-tight">
            {title}
          </h1>

          {/* Event Description */}
          <p className="text-gray-600 mb-5 text-base leading-relaxed">
            {description}
          </p>

          {/* Registration End Date, Eligible Roles, and Special Eligibility Criteria */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm border-t border-gray-200 pt-4">
            <div>
              <span className="font-semibold text-gray-800">Registration Ends:</span>
              <span className="ml-2 text-gray-600">{registrationEndDate}</span>
            </div>
            <div>
              <span className="font-semibold text-gray-800">Eligible Roles:</span>
              <span className="ml-2 text-gray-600">{applicableRoles.join(", ")}</span>
            </div>
            <div>
              <span className="font-semibold text-gray-800">Special Criteria:</span>
              <span className="ml-2 text-gray-600">{specialEligibilityCriteria}</span>
            </div>
            <div>
              <span className="font-semibold text-gray-800">Max Participants:</span>
              <span className="ml-2 text-gray-600">{totalAllowedParticipants}</span>
            </div>
          </div>

          {/* Participants Avatars */}
        <div className="flex flex-col md:flex-row justify-between items-center w-full mt-4">
            <div className="w-full ">
          <div className="flex justify-between ">
            <div className="flex -space-x-4">
            {/* Example Avatars */}
            {imageCodes.map((code, index) => (
              <img
                key={index}
                className="w-10 h-10 rounded-full border-2 border-white shadow-lg"
                src={`https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-${code}.jpg?size=338&ext=jpg&ga=GA1.1.2008272138.1726704000&semt=ais_hybrid`}
                alt={`Participant ${index + 1}`}
              />
            ))}
              {/* <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm shadow-lg">
                ...
              </div> */}
            </div>
            <div className="flex items-center space-x-3">
            <button 
            // onClick={() => handleSendMail()} 
            className="bg-blue-500 text-white py-2 px-4 rounded-full shadow-lg hover:bg-blue-600 mr-3"
          >
            Send Mail
          </button>

            <div onClick={()=>handleOpen()} className="text-3xl border-gray-700 border-2 rounded-full p-1 hover:bg-gray-300 hover:drop-shadow-xl" > 
              <AiOutlineUsergroupAdd />
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default EventCard;
